export enum MetricProgressState {
  FarBelowTarget = 'far-below-target',
  BelowTarget = 'below-target',
  InTarget = 'in-target',
  AboveTarget = 'above-target'
}
